import React from 'react';
import "./ProjectCardStyle.css";
import Tilt from 'react-parallax-tilt';
import { FaLinkedin, FaExternalLinkAlt, FaArrowRight } from 'react-icons/fa';
import cartoon from "../images/cartoon-compressed.png";

export default function ProgramCard({ id, className, title, description, bullets = [], imageSrc, link, linkLabel = 'View on LinkedIn' }) {
  return (
    <div className='project-window' id={id}>
      <div className={`project-wrapper ${className || ''}`}>
        <div className="about-project">
          <div className="project-title">{title}</div>
          {description && <div className="desc">{description}</div>}
          {bullets && bullets.length > 0 && (
            <ul className="program-points">
              {bullets.map((point, idx) => (
                <li key={idx}>{point}</li>
              ))}
            </ul>
          )}
          {link && (
            <a className='btn' href={link} target="_blank" rel="noopener noreferrer">
              {link.includes('linkedin.com') ? (
                <>
                  <span>View on</span>
                  <FaLinkedin className="social" size={20} style={{ marginLeft: "8px", position: "relative", top: "2px" }} />
                  <FaArrowRight className='btn-arrow' size={22} style={{marginLeft: "1rem"}}/>
                </>
              ) : (
                <>
                  <span>{linkLabel || 'Show Credential'}</span>
                  <FaExternalLinkAlt className="social" size={18} style={{ marginLeft: "8px", position: "relative", top: "2px" }} />
                  <FaArrowRight className='btn-arrow' size={22} style={{marginLeft: "1rem"}}/>
                </>
              )}
            </a>
          )}
        </div>
        <Tilt className="project-img" gyroscope={true}>
          <a href={link || '#'} target={link ? "_blank" : undefined} rel={link ? "noopener noreferrer" : undefined}>
            <img
              src={imageSrc || cartoon}
              alt="Program or Course"
              onError={(e) => {
                e.currentTarget.onerror = null;
                e.currentTarget.src = cartoon;
              }}
            />
          </a>
        </Tilt>
      </div>
    </div>
  )
}


